import React from "react"
import { Link } from "gatsby"
import Globals from "../hooks/globals"
import PropTypes from "prop-types"

const ExLink = ({ to, className, children }) => {
    if (Globals.isInternal(to)) {
        return <Link to={to} activeClassName="active" className={className}>{children}</Link>
    } else {
        return <a href={to} className={className}>{children}</a>
    }
}

export default ExLink

ExLink.propTypes = {
    to: PropTypes.string.isRequired,
}
